import React, {useEffect} from 'react';
import {AppBar, LoadingProgress} from "../../components";
import {mostrarAdminCuadreById} from '../../redux/reducers/adminCuadresReducers';
import {Box} from "@mui/material";
import {useParams} from "react-router-dom";
import {formatDate, formatPeso} from "../../helpers";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import CuadrePagos from "./CuadrePagos";

export default function  CuadreDetalle() {
    const dispatch = useAppDispatch();
    let { cuaId } = useParams();

    const { byId, status} = useAppSelector(state=>state.adminCuadres);


    useEffect(() => {
        if(cuaId) {
            dispatch(mostrarAdminCuadreById(+cuaId))
        }
    }, [dispatch, cuaId]);


    return <>
        <AppBar />

        <section className="contentInner" style={(status === "loading")?{opacity:.8}:{opacity:1}}>
            {(status === "loading") && <LoadingProgress vh/>}

            <Box display={"flex"} justifyContent={"end"} pb={1}>
                <table style={{textAlign: "right"}} className={"noHover"}>
                    <tbody>
                        <tr>
                            <th>Fecha Creación:</th>
                            <td>{formatDate(byId?.fechaCreacion)}</td>
                        </tr>
                        <tr>
                            <th>Monto:</th>
                            <td>{formatPeso(byId?.monto)}</td>
                        </tr>
                        <tr>
                            <th>Creado por:</th>
                            <td> {byId?.usuarioCreadoPor}</td>
                        </tr>
                    </tbody>
                </table>
            </Box>

            <CuadrePagos bancosPagos={byId?.detalle}/>
        </section>
    </>;


}